import React from 'react';
import { IoSearchOutline } from "react-icons/io5";
import './SearchBar.css';

const SearchBar = ({ placeholder, value, onChange, style, onSearch }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch();
    }
  };

  return (
    <div className="search-bar-container" style={style}>
      <input
        type="text"
        className="search-bar-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
      <div className="search-bar-icon-container" onClick={onSearch} style={{ cursor: 'pointer' }}>
        <IoSearchOutline className="search-bar-icon" />
      </div>
    </div>
  );
};

export default SearchBar;
